import React, { useState, useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Nav } from "./Nav";
import { Footer } from "./Footer";
import { DemoModal } from "./DemoModal";
import { ThemeProvider } from "./ThemeContext";
import { Toaster } from "sonner";

export const Layout = () => {
    const [demoOpen, setDemoOpen] = useState(false);
    const location = useLocation();

    useEffect(() => {
        if (location.hash) {
            const id = location.hash.slice(1);
            const t = setTimeout(() => {
                const el = document.getElementById(id);
                if (el) {
                    const y = el.getBoundingClientRect().top + window.scrollY - 100;
                    window.scrollTo({ top: y, behavior: "smooth" });
                } else {
                    window.scrollTo({ top: 0, behavior: "instant" });
                }
            }, 360);
            return () => clearTimeout(t);
        }
        window.scrollTo({ top: 0, behavior: "instant" });
    }, [location.pathname, location.hash]);

    useEffect(() => {
        window.__openDemo = () => setDemoOpen(true);
        return () => {
            delete window.__openDemo;
        };
    }, []);

    return (
        <ThemeProvider>
            <div className="App bg-warm">
                <Nav onOpenDemo={() => setDemoOpen(true)} />
                <main className="relative z-10 pt-24">
                    <Outlet context={{ openDemo: () => setDemoOpen(true) }} />
                </main>
                <Footer onOpenDemo={() => setDemoOpen(true)} />
                <DemoModal open={demoOpen} onClose={() => setDemoOpen(false)} />
                <Toaster
                    theme="light"
                    position="bottom-right"
                    toastOptions={{
                        style: {
                            background: "#ffffff",
                            border: "1px solid #ede8e0",
                            color: "#1a1817",
                            boxShadow: "0 8px 24px rgba(80,60,45,0.10)",
                        },
                    }}
                />
            </div>
        </ThemeProvider>
    );
};

export default Layout;
